module.exports = __webpack_public_path__ + "img/us_qualification4.908bbdaa.jpg";